module.exports = __webpack_public_path__ + "img/scanCreation.2e2795d5.svg";